<template>
    <div class="bg-fa">
        <AppHeader fixed>
            <div class="max-cs-container">
                <b-row>
                    <b-col md="6">
                        <div><img src="go-fix.png" alt="logo go fix" class="lager"></div>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <div><span @click="logout" class="">Logout</span></div>
                    </b-col>
                </b-row>
            </div>
        </AppHeader>
        <div class="cs-mcr-2fa">
            <div class="box">
                <div class="content">
                    <div class="l-title">Requires Two-Factor Authentication</div>
                    <div class="step">
                        <div class="item">
                            <div class="m-content">
                                Enter the 6-digit code below from your Code Generator or a third-party app
                            </div>
                            <div class="m-form">
                                <b-form v-on:submit.prevent class="form-vertical login-form formV2 text-center" autocomplete="off">
                                    <div class="six-number">
                                        <gofix-form-input-number 
                                            :integer-limit="6" 
                                            :include-thousands-separator="false" 
                                            :allowDecimal="false" 
                                            class="w-200" 
                                            label="" 
                                            v-model="code">
                                        </gofix-form-input-number>
                                    </div>
                                    <b-row>
                                        <b-col md="8" class="text-left">
                                            <div class="not-yet-qr"><span @click="setUpMFA">Not yet set up?</span></div>
                                        </b-col>
                                        <b-col md="4">
                                            <div class="form-actions">
                                                <gofix-button label="Continue" @click="verifyCode" :loading="isAction" type="button" variant="primary" class="submit btn pull-right"> 
                                                </gofix-button>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </b-form>
                            </div>
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
        <b-modal :no-close-on-backdrop="true" 
            :no-close-on-esc="true"
            hide-footer
            modal-class="modal-2fa"
            id="modal-Create-Check-User" 
            :title="modals.twofa.title" 
            :centered="true" 
            v-model="modals.twofa.open" 
            :hide-header-close="true"
            ref="modal-check">
            <div v-bind:class="{'run-loading':loading}" >
                <div class="pl-10 pr-10">
                    <div class="twofa-text">
                        <div class="twofa-img">
                            <img src="img/icon_method_generator.png">
                        </div>
                        <div class="twofa-txt">
                            <strong>Setup via Third-Party Validator</strong>
                            <p>Please use your authenticator app (Microsoft Authenticator) to scan this QR code and enter code to input.</p>
                        </div>
                    </div>
                    <div class="qrcode">
                        <b-row>
                            <b-col md="6">
                                <div class="b-qr">
                                    <img alt="" :src="modals.twofa.data.qrcode">
                                </div>
                            </b-col>
                            <b-col md="6">
                                <div class="secret-box">
                                    <span>Or enter this code in your authenticator app</span>
                                    <div class="key">{{ modals.twofa.data.secret }}</div>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <div class="actions">
                    <b-button-group class="d-block text-right">
                        <gofix-button label="CANCEL" @click="close2FA" noBorder dark></gofix-button>
                        <gofix-button :loading="modals.twofa.loading" @click="continueStep" label="CONTINUE" noBorder></gofix-button>
                    </b-button-group>
                </div>
            </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="Two-factor authentication" hide-footer hide-header :centered="true" v-model="modals.cancel2FA.open">
            <div class="center">You <strong>2fa</strong> setup has not finished? <br/> Do you want to cancel the setup?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.cancel2FA.open = false">No</b-button>
                <b-button class="custom-btn" @click="cancelSetup2FA">Yes</b-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';
	import { validationMixin } from 'vuelidate'
	import { required, minLength,email } from 'vuelidate/lib/validators'
	import { floatLabel } from '@/_floatLableClass.js'
    import { Header as AppHeader, SidebarToggler } from '@coreui/vue'
export default {
  	name: 'Microsoft2FA',
  	data () {
      return {
		code:null,
		isAction : false,
        loading:false,
        mfa_secret_key:null,
        modals:{
            twofa:{
                qrCode:null,
                open:false,
                title:'Two-factor authentication',
                data:{
                    qrcode:null,
                    secret: null
                }
            },
            cancel2FA: {
                open: false
            }
        },
        hideSetUp:true,
      }
      
  	},
    components: {
        AppHeader,
        SidebarToggler
    },
  	computed: {
        ...mapGetters({
            UserLogin: "AuthController/user"
        }),
    },
	watch: {

	},
    mounted: async function() {
		floatLabel();
        this.getSecretKey();
	},
	updated: async function() {
		await this.$nextTick();
		await floatLabel()
	},
  	methods:{
        async getQRCode(){
            this.loading = true;
            this.$store.dispatch( 'AuthController/getQRCode', null)
            .then(async response =>{
                this.modals.twofa.data = response.data;
                this.loading = false;
            })
            .catch(error=>{
                this.loading = false;
            })
        },
        async setUpMFA(){
            this.getQRCode();
            this.modals.newMFA = false;
            this.modals.twofa.open = true;
            return;
        },
        async getSecretKey(){
            this.hideSetUp = true;
            let user = JSON.parse(localStorage.getItem('user_info'));
            let params = {
                email: user.email
            };
            this.$store.dispatch( 'AuthController/getMFASecretKey', params)
            .then(async response =>{
                if(!response || (response && !response.mfa_secret_key)){
                    this.hideSetUp = false;
                }
                if(response && response.mfa_secret_key){
                    this.mfa_secret_key = response.mfa_secret_key;
                }
            })
            .catch(error=>{
                this.hideSetUp = true;
            })
        },
        async continueStep(){
            this.modals.twofa.open = false;
            this.hideSetUp = true;
            let request = {
                email:this.UserLogin.email,
                mfa_secret_key: this.modals.twofa.data.secret
            };
            this.$store.dispatch(`AuthController/updateSecretKey`, request);
        },
		async verifyCode(){
            let params = {
                code: this.code
            };
            if(this.mfa_secret_key){
                params.microsoft2fa_secret = this.mfa_secret_key;
            }
            if(!this.code){
                return this.$alertNotification("The Code is required", "danger");
            }
            if(this.code.length != 6){
                return this.$alertNotification("Please fill code with 6 digits!", "danger");
            }
			this.isAction = true;
			this.$store.dispatch( 'AuthController/verifyCode', params)
			.then(async response =>{
                this.$store.commit('AuthController/verifyCodeTwoFA', true);
                this.$store.commit('AuthController/setEnableMFA', true);
                this.$alertNotification(response.data.data.message, "success");
				document.querySelector("iframe#_goFixLoginIframe").contentWindow.postMessage({
                    type: "gofix_lm_remove_session_twofa"
                }, process.env.VUE_APP_SERVER_URL_AUTH);
                try {
                    setTimeout(async () => {
                        localStorage.setItem('user_info', JSON.stringify(this.UserLogin));
                        if(this.$route.query.from){
                            this.$router.push(this.$route.query.from);
                            return;
                        }
                        //redirect
                        if(this.UserLogin && this.UserLogin.roles){
                            const arrTmp = this.UserLogin.roles.filter(item => item.name.toUpperCase() == 'NLT CSO')
                            if(arrTmp.length) {
                                localStorage.setItem("isNLTCso", 1);
                                this.$router.push(`/case/list`);
                                return;
                            }
                        }
                        if(this.UserLogin && this.UserLogin.organization && this.UserLogin.organization.is_supplier){
                            this.$router.push('/supplier-portal/dashboard');
                            return;
                        }
                        this.$router.push('/v2/dashboard');
                    },500);
                } catch (error) {
                    console.log(error)
                }
				this.isAction = false;
			})
			.catch(error=>{
                console.log(error)
				this.isAction = false;
                return this.$alertNotification(error.response.data.error.message, 'danger');
			})
		},
        async logout() {
            if(goFix){
                await goFix._logout();
            }else{
                this.$store.dispatch('AuthController/logout')
                    .then(result => {
                        this.$store.reset();
                        this.$router.push(`/login`)
                    })
                    .catch(error => {
                        this.$router.push(`/login`)
                    })
            }
            localStorage.clear();
        },
        close2FA() {
            this.modals.cancel2FA.open = true;
        },
        cancelSetup2FA() {
            this.modals.cancel2FA.open = false;
            this.modals.twofa.open = false;
        }
  	}
}
</script>